import { APP_ENV, ORG_NAME } from 'utils/env'

export const createRevenueCenterImageUrl = (standUuid) => {
  const orgName = ORG_NAME
  const env = APP_ENV
  const timeStamp = new Date().valueOf()

  return `https://d2bekohrrq5iy7.cloudfront.net/${orgName}/${env}/stands-tout-${standUuid}.webp?${timeStamp}`
}
